function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Menu/Iconen/Plattegrond-blauw",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("line", {
  x1: 15,
  y1: 21,
  x2: 25.7139893,
  y2: 21,
  id: "Line-8",
  stroke: "#425CD4",
  strokeWidth: 0.5,
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("line", {
  x1: 19.75,
  y1: 21.25,
  x2: 20.25,
  y2: 24.75,
  id: "Line-12",
  stroke: "#425CD4",
  strokeWidth: 0.5,
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("line", {
  x1: 9.625,
  y1: 16.125,
  x2: 9.5,
  y2: 17.5,
  id: "Line-12",
  stroke: "#425CD4",
  strokeWidth: 0.5,
  strokeLinecap: "square",
  strokeLinejoin: "bevel"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path-5",
  stroke: "#425CD4",
  strokeWidth: 0.5,
  points: "8 29.8342285 9.11669922 20.8342285 11.7138672 20.8342285"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#425CD4",
  strokeWidth: 0.5,
  x: 0.25,
  y: 0.25,
  width: 29.5,
  height: 29.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M19,4 C20.3260824,4 21.597852,4.51679098 22.5355339,5.43668484 C23.4732158,6.35657869 24,7.60422249 24,8.90514886 C24,10.9991024 21.0133333,14.9831733 19.6566667,16.685805 C19.4987367,16.8841043 19.2565151,17 19,17 C18.7434849,17 18.5012633,16.8841043 18.3433333,16.685805 C16.9866667,14.9842633 14,10.9991024 14,8.90514886 C14,6.19610995 16.2385763,4 19,4 Z",
  id: "Path",
  stroke: "#425CD4",
  strokeWidth: 0.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path-3",
  stroke: "#425CD4",
  strokeWidth: 0.5,
  points: "0.51184082 29.7766113 6.30500412 16 17.6994629 16"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path-6",
  stroke: "#425CD4",
  strokeWidth: 0.5,
  points: "20.2542725 16 24 16 29.3284912 29.7766113"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  stroke: "#425CD4",
  strokeWidth: 0.5,
  cx: 19,
  cy: 9,
  r: 2
}));
function SvgMapBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Menu/Iconen/Plattegrond blauw") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapBlue);
export default __webpack_public_path__ + "static/media/Map_blue.bd053d932a37e8ade89cc8d9494ed774.svg";
export { ForwardRef as ReactComponent };